import React from "react";
import SkillItem from "./SkillItem";

const Skills = () => {
  return (
    <div className="py-4">
      <div className="flex flex-wrap">
           <SkillItem/>
      </div>
    </div>
  );
};

export default Skills;
